import React, { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { getRecoil, resetRecoil } from "recoil-nexus";
import styled from "styled-components";
import ApiController from "../controller/ApiController";
import LogController from "../controller/LogController";
import { qrAuthState } from "../recoil/auth";
import { eventState, EventStateType } from "../recoil/event";
import { LANG_KO, langState, langText } from "../recoil/lang";

let timer: any;

const boxList = [
  {
    type: "center",
    list: [
      { img: "gift_box_yellow", id: 0 },
      { img: "gift_box_mint", id: 1 },
    ],
  },
  {
    type: "between",
    list: [
      { img: "gift_box_pink", id: 2 },
      { img: "gift_box_green", id: 3 },
      { img: "gift_box_purple", id: 4 },
    ],
  },
];

const RandomBox = () => {
  const lang = useRecoilValue<number>(langState);
  const [event, setEvent] = useRecoilState<EventStateType>(eventState);

  const [isStart, setIsStart] = useState<boolean>(false);
  const [selectedBox, setSelectedBox] = useState<number>(-1);
  const [animationStatus, setAnimationStatus] = useState<number>(0);

  // API 이벤트 쿠폰 발급
  const setEventCoupon = async () => {
    try {
      if (event.event_id) {
        const response = await ApiController.store.setEventCoupon(
          event.event_id,
          getRecoil(qrAuthState).user_id,
          getRecoil(qrAuthState).user_token_id
        );

        if (response && response.data) {
          const oRes = response.data;
          if (oRes && oRes.success) {
            setEvent({
              ...event,
              coupon: oRes.coupon,
            });
            LogController.click({
              path: "RandomBox",
              params: "event",
              params2:
                event.event_name +
                "선물상자 이벤트 당첨 (금액:" +
                response.data.coupon.price +
                ")",
              index: event.event_id,
            });
          }
        }
        setAnimationStatus(2);
        setIsStart(false);
        clearTimeout(timer);
      }
    } catch (err) {
      console.log("getAdverList err-->", err);
    }
  };

  const openBoxAnimation = (index: number) => {
    console.log("aniSta", animationStatus);
    if (animationStatus === 0) {
      setSelectedBox(index);
      setAnimationStatus(1);
      timer = setTimeout(() => {
        setEventCoupon();
      }, 800);
    }
  };

  const onCloseModal = () => {
    resetRecoil(eventState);
  };

  const startOrReset = () => {
    clearTimeout(timer);
    setAnimationStatus(0);
    setSelectedBox(-1);
    if (isStart) {
      setIsStart(false);
    } else {
      setIsStart(true);
    }
  };

  useEffect(() => {
    setIsStart(true);
  }, []);

  return (
    <Style>
      {animationStatus === 2 && (
        <div className="overlay">
          <div className="commentWrap">
            <h3>⭐</h3>
            <h3>{langText.christmas_event_coupon_comment[lang]}</h3>
            <h3>🎁</h3>
          </div>
          <button onClick={onCloseModal}>
            <h2>{langText.christmas_event_coupon_button[lang]}</h2>
          </button>
        </div>
      )}
      <div
        className="modal"
        style={{
          backgroundImage: `url(${`${process.env.PUBLIC_URL}/knockknock/img/christmas/random_box_background.png`})`,
        }}
      >
        {lang === LANG_KO ? (
          <div className="titleWrap">
            <h1>{langText.christmas_event_title[lang]}</h1>
            <h2>{langText.christmas_event_subtitle[lang]}</h2>
          </div>
        ) : (
          <img
            className="title"
            src={`${process.env.PUBLIC_URL}/knockknock/img/christmas/random_box_title.png`}
            alt="title"
          />
        )}
        <h3>{langText.christmas_event_comment[lang]}</h3>
        <div className="boxWrap">
          {boxList.map((box, index) => (
            <div key={index} className={`row ${box.type}`}>
              {box.list.map((item, boxIndex) => (
                <div
                  key={boxIndex}
                  className={`box ${
                    isStart && animationStatus === 0 && "start"
                  } ${selectedBox === item.id && "select"} ${
                    selectedBox === item.id &&
                    animationStatus === 1 &&
                    "shaking"
                  }`}
                  onClick={() => openBoxAnimation(item.id)}
                >
                  <img
                    className={`${
                      selectedBox === item.id && animationStatus === 2
                        ? "open"
                        : ""
                    }`}
                    src={`${process.env.PUBLIC_URL}/knockknock/img/game/${
                      item.img
                    }${
                      selectedBox === item.id && animationStatus === 2
                        ? "_open"
                        : ""
                    }.png`}
                    alt="box"
                  />
                  {animationStatus === 2 && event.coupon && (
                    <div className="coupon">
                      <h2>{event.coupon.coupon_name}</h2>
                      <h3>{langText.coupon_won[lang]}🎉</h3>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
        <h3>{langText.christmas_event_comment_footer[lang]}</h3>
        {/* <button onClick={startOrReset}>{isStart ? "RESET" : "START"}</button> */}
      </div>
    </Style>
  );
};
export default RandomBox;

const Style = styled.div`
  @font-face {
    font-family: "Jalnan2TTF";
    src: url("${process.env.PUBLIC_URL}/knockknock/font/Jalnan2TTF.ttf")
      format("truetype");
    font-weight: 400;
  }

  @keyframes vibration {
    from {
      transform: rotate(4deg);
    }
    to {
      transform: rotate(-4deg);
    }
  }

  @keyframes BigVibration {
    0% {
      transform: rotate(10deg);
    }
    50% {
      transform: rotate(-10deg);
    }
    100% {
      transform: rotate(10deg);
    }
  }

  @keyframes showing {
    from {
      transform: translate(-50%, 30%) scale(0.5);
    }
    to {
      transform: translateY(-50%, -30%) scale(1);
    }
  }

  .modal {
    padding: 20% 5% 0 5%;
    width: 100vw;
    height: 100dvh;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5dvh;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 27dvh 5% 11dvh 5%;
    .commentWrap {
      display: flex;
      align-items: center;
      padding: 4px 16px;
      border-radius: 100px;
      background: #ff9500;
      gap: 8px;
      z-index: 3;
      h3 {
        font-size: 14px;
        line-height: 20px;
        font-weight: 600;
      }
    }

    button {
      background: #fff;
      border-radius: 100px;
      padding: 10px 24px;

      h2 {
        font-size: 26px;
        line-height: 32px;
        font-family: "Jalnan2TTF";
        color: #c24035;
      }
    }
  }

  img.title {
    width: 70%;
  }
  .titleWrap {
    text-align: center;
    h1 {
      font-size: 36px;
      line-height: 60px;
      font-weight: 400;
      font-family: "Jalnan2TTF";
    }
    h2 {
      font-size: 24px;
      line-height: 32px;
      font-family: "Jalnan2TTF";
    }
  }

  h3 {
    font-size: 12px;
    line-height: 20px;
    font-weight: 400;
    text-align: center;
  }

  .boxWrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 15dvh 0 0 0;
  }
  .row {
    width: 100%;
    display: flex;
    align-items: flex-end;
  }
  .row.center {
    justify-content: center;
  }
  .row.between {
    justify-content: space-between;
  }

  .box {
    position: relative;
    display: flex;
    justify-content: center;
    width: 34vw;
    height: 27vw;
    margin: -5vw -4vw 0 -4vw;
    transform-origin: center;
    img {
      width: 20vw;
      height: 20vw;
    }
    img.open {
      margin-top: -11vw;
      margin-left: -14px;
      width: 32vw;
      height: 32vw;
    }
    .coupon {
      display: none;
    }
  }
  .box.select {
    z-index: 2;
    .coupon {
      position: absolute;
      top: 5%;
      left: 50%;
      transform: translate(-50%, -30%) scale(1);
      transform-origin: center;
      width: fit-content;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: 50px;
      background: #00000080;
      padding: 6px 16px;
      scale: 1;
      animation: showing 0.2s ease-in-out;
      z-index: 2;
      h2 {
        font-size: 14px;
        line-height: 22px;
        color: #fff;
        font-weight: 700;
        white-space: nowrap;
      }
      h3 {
        font-size: 12px;
        line-height: 18px;
        font-weight: 500;
        white-space: nowrap;
        color: #fff;
      }
    }
  }
  .box.start {
    transform: translateX(0);
    transition: transform 0.5s ease-in;
    animation: BigVibration 2s infinite;
  }
  .box.shaking {
    animation: vibration 0.15s infinite;
  }

  button {
    z-index: 100;
    padding: 10px 20px;
    border-radius: 10px;
    background: #fff;
    h2 {
      font-size: 16px;
    }
  }
`;
